/**
 * VM-14b — Kleine UI-Bausteine für den Composer.
 * Extrahiert aus MessagingDialog.jsx.
 */
import { Checkbox } from "@/components/ui/checkbox";

export function ChannelBox({ checked, onChange, icon, title, hint, children, testid }) {
  return (
    <label className="bg-white border border-slate-200 rounded-md p-3 cursor-pointer hover:border-slate-300 transition-colors block">
      <div className="flex items-start gap-2">
        <Checkbox checked={checked} onCheckedChange={onChange} className="mt-0.5" data-testid={testid} />
        <div className="flex-1">
          <div className="flex items-center gap-2 text-sm font-semibold text-slate-800">{icon}{title}</div>
          <div className="text-[11px] text-slate-500 mt-0.5">{hint}</div>
          {children}
        </div>
      </div>
    </label>
  );
}

/** VM-7b — kompakter Toolbar-Button für mobile Ansicht.
 * iter138 — Mobile-Fixes:
 *  - Verwendet onPointerDown + touch-action:manipulation, damit die Selektion
 *    im Editor NICHT verloren geht (iOS Safari + Android Chrome).
 *  - Unterstützt neben Toggle-Aktionen auch Text-Alignment via `align`-Prop.
 */
export function MobileEditorButton({ editor, action, label, bold, italic, underline, align, testid }) {
  if (!editor) return null;
  const isActive =
    align ? editor.isActive({ textAlign: align }) :
    action === "toggleBold" ? editor.isActive("bold") :
    action === "toggleItalic" ? editor.isActive("italic") :
    action === "toggleUnderline" ? editor.isActive("underline") :
    action === "toggleBulletList" ? editor.isActive("bulletList") :
    action === "toggleOrderedList" ? editor.isActive("orderedList") :
    false;
  const style = {
    fontWeight: bold ? 700 : undefined,
    fontStyle: italic ? "italic" : undefined,
    textDecoration: underline ? "underline" : undefined,
    touchAction: "manipulation",
  };
  const run = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (align) {
      editor.chain().focus().setTextAlign(align).run();
    } else if (action) {
      editor.chain().focus()[action]().run();
    }
  };
  return (
    <button
      type="button"
      onPointerDown={run}
      onMouseDown={(e) => e.preventDefault()}
      className={`shrink-0 min-w-[36px] h-9 px-2 rounded text-sm border transition-colors select-none ${
        isActive
          ? "bg-slate-900 text-white border-slate-900"
          : "bg-white text-slate-700 border-slate-200 hover:bg-slate-100 active:bg-slate-200"
      }`}
      style={style}
      data-testid={testid}
      aria-label={label}
    >{label}</button>
  );
}
